module.exports = __webpack_public_path__ + "static/img/jianmeisheng.4710c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/jianmeisheng.jpg
// module id = b4x4
// module chunks = 0